module.exports = __webpack_public_path__ + "media/images/img_plus-engineer-3e5747a669708d43fa47c04dd93fb705.png";